import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/desktop/HeroSection.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
